import { gql } from 'apollo-boost'

// Still not sure where exactly to look for the types to be used in this gql thingy
// so far got ID, String, Int

// id for department and position ain't used, but without them got a strange error in the manager dropdown of userprofile
export const dictUsers = gql`
  query Users($companyId: ID, $departmentId: ID, $userId: ID) {
    users(companyId: $companyId, departmentId: $departmentId, userId: $userId) {
      name
      id
      email
      company {
        id
        name
        country
      }
      department {
        id
        name
      }
      position {
        id
        name
      }
      weight
    }
  }
`
export const dictDepartments = gql`
  query Departments($companyId: ID) {
    departments(companyId: $companyId) {
      name
      id
    }
  }
`
export const dictCompanies = gql`
  {
    companies {
      name
      id
    }
  }
`
export const dictExpenseTypes = gql`
  query ExpenseTypes($subType: String) {
    expenseTypes(subType: $subType) {
      name
      id
    }
  }
`
export const dictProcurementTypes = gql`
  query ProcurementTypes($subType: String) {
    procurementTypes(subType: $subType) {
      name
      id
    }
  }
`
export const dictUserGroups = gql`
  {
    userGroups {
      name
      id
    }
  }
`

export const dictPositions = gql`
  {
    positions {
      name
      id
    }
  }
`
export const dictRoles = gql`
  {
    roles {
      name
      id
    }
  }
`
export const dictRoutes = gql`
  {
    companies {
      name
      id
    }
  }
`
export const dictTypesOfApplication = gql`
  {
    typesOfApplication {
      name
      id
    }
  }
`
export const dictSigningPath = gql`
  query SigningPaths($companyId: ID) {
    signingPaths(companyId: $companyId) {
      name
      id
      numberOfLevels
    }
  }
`
export const dictMethodsOfTransport = gql`
  query MethodsOfTransport {
    methodsOfTransport {
      name
      id
    }
  }
`
